import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  quotesByTime: {},
  quotesByClients: {},
  userSummary: {
    quotes: [],
    confirmed: [],
  },
  requestsByStages: {},
  requestsByDestinations: {},
};

const reports = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default reports;
